function initTabScroll(el) {
  const body = document.body;
  const scrollUp = 'scroll-up';
  const scrollDown = 'scroll-down';
  let lastScroll = 0;

  el.addEventListener('scroll', () => {
    const currentScroll = el.scrollTop;

    if (currentScroll <= 50) {
      body.classList.remove(scrollUp);
      return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
      // up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }

    lastScroll = currentScroll;
  });
}

function deinitTabScroll(el) {
  el.removeEventListener('scroll', initTabScroll);
}

function getTabScrollContent(tab) {
  const pane = document.getElementById(tab.getAttribute('data-bs-target').replace('#', ''));
  return pane ? pane.querySelectorAll('.content')[0] : null;
}

export default function initStickyNav() {
  const nav = document.getElementsByClassName('nav-sticky')[0];

  if (nav) {
    const tabs = nav.querySelectorAll('.nav-link');

    if (tabs.length) {
      // All tabs
      tabs.forEach((tab) => {
        const el = getTabScrollContent(tab);

        tab.addEventListener('shown.bs.tab', () => {
          deinitTabScroll(el);
          initTabScroll(el);
        });
      });

      // First tab
      const el = getTabScrollContent(tabs[0]);
      initTabScroll(el);
    }
  }
}
